import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from 'src/api/apiClient';
import { SPROUTS_AGENT_BASE_URL } from 'src/constants/httpEndPoints';

export const getThreadId = createAsyncThunk<string, void>('sproutsAgent/getThreadId', async () => {
  const body = {
    thread_id: '',
    metadata: {},
    if_exists: 'raise',
  };
  const res = await apiClient.post(SPROUTS_AGENT_BASE_URL, body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data.thread_id;
});
